
const CONFIG = "config";

export class EpDevPConifgApiRoutesFactory {

  public static getSubRouteBase = (): string => {
    return `/${CONFIG}`;
  }
  public static getSubRouteGet = (): string => { 
    return EpDevPConifgApiRoutesFactory.getSubRouteBase();
  }
}

export class EpDevPConifgApiPathsFactory {

  public static createGetPath(): string {
    return `/${CONFIG}`;
  }

}
